const convertSvgToPngBase64 = (svgUrl) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.src = svgUrl;

        img.onload = () => {
            const canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            const pngBase64 = canvas.toDataURL("image/png");
            resolve(pngBase64);
        };

        img.onerror = (error) => reject(error);
    });
};

module.exports = {
    convertSvgToPngBase64,
};
